import styled from 'styled-components';
// components
import Text from 'components/Text';
import Loading from 'components/Loading';
import { colors } from 'pages/Quotes/styles/colors';

export const SwitchInput = styled.input.attrs({
  type: "checkbox"
})`
  width: 0 !important;
  height: 0 !important;
  visibility: hidden;
  display: none;
`;

interface SwitctProps {
  disableTabs?: boolean;
  toggled: boolean;
  isLine: boolean;
}

export const ToggleContent = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: left !important;
`;

export const TextLabel = styled(Text) <SwitctProps>`
  color: ${props => props.toggled ? colors.white : colors.gray1};
  margin: ${props => props.toggled ? "0 0 0 12%" : "0 0 0 24%"};
  font-size: 13px !important;
`;

export const SwitchLabel = styled.label<SwitctProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: ${props => props.disableTabs ? "not-allowed" : "pointer"};
  width: ${props => props.isLine ? "86px" : "170px"};
  height: ${props => props.isLine ? "20px" : "35px"};
  border-radius: 100px;
  border: 2px solid ${props => props.toggled ? colors.viveoDarkBlue : colors.gray1};
  background: ${props => props.toggled ? colors.viveoDarkBlue : colors.grayLight};
  position: relative;
  transition: background-color .3s;

  > .sk-circle {
    z-index: 9999;
    position: absolute;
    left: calc(50% - 5px);
  }
`;

export const SwitchButton = styled.span<SwitctProps>`
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: ${props => props.isLine ? "12px" : "27px"};
  height: ${props => props.isLine ? "12px" : "27px"};
  border-radius: 45px;
  transition: 0.2s;
  background: ${props => props.toggled ? colors.white : colors.gray1};
  box-shadow: 0 0 2px 0 rgba(10, 10, 10, 0.29);
  ${SwitchInput}:checked + ${SwitchLabel} & {
    left: calc(100% - 2px);
    transform: translateX(-100%);
  }
`;

export const Loader = styled(Loading).attrs({
  size: 14
})``;